module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-block"
  }, [_c('div', {
    staticClass: "footer-text"
  }, [(_vm.props.acf.footer_left_section_title) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer_left_section_title)
    }
  }) : _vm._e(), (_vm.props.acf.address) ? _c('div', {
    staticClass: "address_foot",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.address)
    }
  }) : _vm._e(), (_vm.props.acf.phone) ? _c('a', {
    staticClass: "footer-main__link",
    attrs: {
      "href": "tel:" + _vm.props.acf.phone,
      "itemprop": "telephone"
    }
  }, [(_vm.props.acf.phone) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone)
    }
  }) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "footer-text"
  }, [(_vm.props.acf.footer_middle_section_title) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer_middle_section_title)
    }
  }) : _vm._e(), (_vm.props.acf.working_hours) ? _c('div', {
    staticClass: "working_hours",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.working_hours)
    }
  }) : _vm._e(), (_vm.props.acf.follow_us_title) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.follow_us_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "social-media"
  }, [_c('ul', [_c('li', [(_vm.props.acf.instagram_url) ? _c('a', {
    attrs: {
      "href": _vm.props.acf.instagram_url,
      "target": "_blank"
    }
  }, [(_vm.props.acf.instagram_icon) ? _c('i', {
    staticClass: "fa",
    class: _vm.props.acf.instagram_icon
  }) : _vm._e()]) : _vm._e()])])])]), _c('div', {
    staticClass: "footer-text"
  }, [(_vm.props.acf.footer_right_section_title) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer_right_section_title)
    }
  }) : _vm._e(), (_vm.props.acf.pay_rent_url) ? _c('a', {
    attrs: {
      "href": _vm.props.acf.pay_rent_url,
      "target": "_blank"
    }
  }, [(_vm.props.acf.pay_rent_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.pay_rent_text)
    }
  }) : _vm._e()]) : _vm._e(), (_vm.props.acf.maintenance_url) ? _c('router-link', {
    attrs: {
      "to": _vm.props.acf.maintenance_url
    }
  }, [(_vm.props.acf.maintenance_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.maintenance_text)
    }
  }) : _vm._e()]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("© " + _vm._s(new Date().getFullYear()) + " "), (_vm.props.acf.copyright_section_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.copyright_section_text)
    }
  }) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0210ee58","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 520
// module chunks = 1